import './jquery-global'

import TechDivisionNodeTypesBlogFilterDropdown from './Modules/TechDivisionNodeTypesBlogFilterDropdown'

const initNodeTypesOnLoad = function () {
    new TechDivisionNodeTypesBlogFilterDropdown()
}

if (document.readyState != 'loading') {
    initNodeTypesOnLoad()
} else {
    document.addEventListener('DOMContentLoaded', initNodeTypesOnLoad)
}
